'use strict';

/**
 * @ngdoc service
 * @name posApp.checkoutInit
 * Service that is injected to set up checkout dependecies
 */
angular
  .module('posApp')
  .service(
    'checkoutInit',
    (
      $rootScope: ng.IRootScopeService,
      displayMessage: any,
      paymentTypes: any,
      pinProvider: any,
      pos: any,
      legacyPrint: any,
      translate: any,
    ) => {
      const checkoutInit: any = {},
        $translate = translate;

      // Hack! To be replaced by custom operator rx operator
      const wrapInSafeApply = require('../../../../global/wrap-in-safe-apply')(
        $rootScope,
      );

      // Only init if the connected PayPlaza terminal is used
      if (
        paymentTypes.rules &&
        paymentTypes.rules.pin &&
        paymentTypes.rules.pin.coupled === true
      ) {
        pinProvider.init();

        pinProvider.print$.subscribe(
          wrapInSafeApply((printOut: any) => {
            legacyPrint.preformattedData(printOut);
          }),
        );

        pinProvider.appName$.subscribe(
          wrapInSafeApply((aidCard: string) => {
            pos.transaction.cardType = aidCard;
          }),
        );

        pinProvider.transactionId$.subscribe(
          wrapInSafeApply((transactionId: string) => {
            pos.transaction.elecTransId = transactionId;
            pos.persist('TRANS', pos.transaction);
          }),
        );

        pinProvider.errorMessage$.subscribe(
          wrapInSafeApply((message: string) => {
            displayMessage.message({
              // is called with values from pay plaza, examples for which tests were
              // written: 'PINServiceUnavailable', 'PINErrorFatal'
              message: $translate.instant(message),
              type: 'errorprompt',
              ok: true,
              callback: null,
            });
          }),
        );

        pinProvider.retryMessage$.subscribe(
          wrapInSafeApply((message: string) => {
            // is called with values from pay plaza, examples for which tests were
            // written: 'PINErrorFatal',
            displayMessage.message($translate.instant(message));
          }),
        );
      }

      checkoutInit.processingTransaction = false;
      $rootScope.$on('posFinishedTransaction', () => {
        checkoutInit.processingTransaction = false;
      });

      /*
       * Generic even fired when the retry mechanism is aborted by the user
       */
      $rootScope.$on('appHandleDataError', (l, resource) => {
        //Reset the buttons, navbar, search field
        if (resource === undefined || resource == 'transaction') {
          checkoutInit.processingTransaction = false;
        }
      });

      return checkoutInit;
    },
  );
